import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { citizenBaseUrl } from "@egovernments/digit-ui-module-core/src/pages/citizen/citizenPageUrls";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ScrutinyRemarksContext } from "../../../../Context/remarks-data-context";
import { useLocation } from "react-router-dom";

const useEmpLandUse = (formData, workflowDetails, userRolesArray) => {
  const { id } = useParams();
  const { t } = useTranslation();

  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState(null);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData?.documents);
  const [taxHead, setTaxHead] = useState([]);
  const [mandatoryCondition, setMandatoryCondition] = useState("");
  const [officerNocDetails, setOfficerNocDetails] = useState(formData?.nocDetails);
  const [isNoNoc, setIsNoNoc] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [khasraRemarks, setKhasraRemarks] = useState(formData?.khasraRemarks || "");
  // Normal remarks
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  // Document Remarks
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState("");
  const [notingRemarksData, setNotingRemarksData] = useState({});
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const isEE = userRolesArray?.[0]?.code === "EE";
  const isATP = userRolesArray?.[0]?.code === "ATP";
  const isEmployee = history.location.pathname.includes("employee");
  const isDa = formData?.department === "DA";
  const isCitizen = user?.info?.type === "CITIZEN";
  const inspectionReportChecklist = useSelector((state) => state.inspectionReportChecklist);
  const reduxFormData = useSelector((state) => state?.inspectionReportData);
  const userRolesWithoutEMP = user?.info?.roles.filter((user) => user.code != "EMPLOYEE");
  const Modal = useModal();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source") || "";
  console.log("fromDashboardcheckSource", source);

  const isFromDashboard = source === "dashboard";
  const [initialUrl, setInitialUrl] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [currentView, setCurrentView] = useState("documents");
  const [showToast, setShowToast] = useState(null);
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [loader, setLoader] = useState(false);
  const userInfo = user?.info || {};
  const authToken = user?.access_token || null;
  const closeToast = () => setShowToast(null);
  const [khasraDetailsData, setKhasraDetailsData] = useState([]);
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [additionalComment, setAdditionalComment] = useState("");

  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto"];
  // const { khasraDetailsData, handleGetKhasraById } = useContext(ScrutinyRemarksContext);
  const fetchInitialUrl = async (fileStoreId) => {
    const response = await axios.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    // console.log("responseFromFileStore", response.data.fileStoreIds[0].url);
    // setInitialUrl(response.data.fileStoreIds[0].url);
    if (response.data.fileStoreIds[0].url) {
      setIframeSrc(response.data.fileStoreIds[0].url);
    }
    // return response.data.fileStoreIds[0].url || "";
  };
  const stripHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || ""; // Get the plain text
  };
  useEffect(() => {
    if (documentSection?.[0]?.fileStoreId) {
      fetchInitialUrl(documentSection?.[0]?.fileStoreId);
    }
  }, []);
  const handleGetDocumentById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeCheckBox = (event) => {
    setChecked(event.target.checked);
  };
  const declarationMessage =
    "I, hereby, certify that all the information filled the Application Form by Applicant, has been checked and verified by me and the NOC checklist mentioned above are complete as per the applicable rules and Bylaws.";
  const declarationMessage2 = "I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete.";
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result)); // or result.toString()
    return String(result); // Convert the result to a string before returning
  };
  const normalizeDocuments = (docs) => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const docs = formData?.documents || {};
  const isLowRiskCase = formData?.riskType === "LOW";
  const isKYPForm = formData?.applicationType === "FORM_KYP";
  const department = formData?.department;

  // formData?.descriptionOfLand.schemeType === "Scheme" && formData?.descriptionOfLand?.landUsesType === "Residential";
  // &&
  // formData?.descriptionOfLand?.subLandUseAsPerLayout === "Residential" &&
  // formData?.descriptionOfLand?.landArea <= 2000;
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_LANDUSE", formData);
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);

  const { data: { BPA: { AVPSchemesUnitData: avpData } = {} } = {}, isLoading: isAvpDataLoading } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [
    "AVPSchemesUnitData",
  ]);

  const avpUnits = avpData?.map((item) => {
    return { name: item.Unit, label: item.Unit, value: item.Unit };
  });

  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  const documents = normalizeDocuments(docs);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  let improvedDoc = [];

  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  const { data: pdfDetails, isLoading: docsLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: improvedDoc?.length > 0 ? true : false,
  });

  let applicationDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let tabList = [
    { label: "Application Data", color: "red" },
    !isCitizen && { label: "Document Section", color: "red" },
    { label: "Take Action", color: "red" },
    { label: "NOC Checklist", color: "green" },
    formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible"
      ? !isCitizen && {
          label: "Conditions",
          color: "#fd6d0b",
        }
      : null, // LandUse Checklist)
    { label: "ChatBoard", color: "red" },
  ].filter(Boolean);
  const userRoles = user?.info?.roles?.map((e) => e.code);
  const documentSection = formData?.documents?.filter((doc) => !["signature", "applicantPhoto", "kmlFile"].includes(doc.documentType));
  const getValidityOfEmp = () => {
    if (formData?.assignes?.length > 0) {
      console.log("loggingValidityOfEmp", formData?.assignes?.[0]?.uuid === userInfo?.uuid);

      return formData?.assignes?.[0]?.uuid === userInfo?.uuid;
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  let actions = workflowDetails?.data?.actionState?.nextActions?.filter((e) => {
    return userRoles.some((role) => e.roles?.includes(role)) || !e.roles;
  });
  const handleGetKhasraById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.khasraDetails}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setKhasraDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };

  async function handleSubmit() {
    console.log("isNoNOCApprovalLetter", isNoNoc);
    console.log("loggingActionFromEmpLandUse", currentAction);
    console.log("paramss1111", params);

    const isDocValidated = Digit?.SessionStorage?.get("isDocValidated");
    const isNotingValidated = Digit?.SessionStorage?.get("isNotingValidated");
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    if (!isNotingValidated) {
      Modal("Noting Remark", "Please add Noting Remark and click on Save", "error");
      return;
    }
    if (!isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return;
    }
    if (currentAction?.action == null) {
      console.log("coming here??44444");
      Modal("Action required", "Please select at least one action.", "error");
      return;
    }
    if ((!isKYPForm && !params?.khasraDetails) || params?.khasraDetails?.length < 1) {
      console.log("coming here??333333");
      Modal("Khasra details required", "Please fill relevant khasra information in khasra details section.", "error");
      return;
    }

    if (!isKYPForm && formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible" && Object.keys(mandatoryCondition)?.length < 1) {
      console.log("coming here??2222222");
      Modal("Mandatory condition is required", "Please select mandatory condition from dropdown.", "error");
      return;
    }
    if (!isKYPForm && isATP && formData?.status === "APPLY_FOR_DSC" && !formData?.IsApprovalCertificate) {
      console.log("coming here??111111");
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return;
    }
    if (
      isKYPForm &&
      (!params?.descriptionOfLand?.plotFront ||
        !params?.descriptionOfLand?.plotRear ||
        !params?.descriptionOfLand?.plotSide1 ||
        !params?.descriptionOfLand?.plotSide2 ||
        !params?.descriptionOfLand?.maximumCoverage ||
        !params?.descriptionOfLand?.proposedGoundCoverageSqM ||
        !params?.descriptionOfLand?.landLength)
    ) {
      console.log("coming here??111111");

      Modal("Plot details values missing", "Please fill the coverage, setabcks, fars and permissible height values", "error");
      return;
    }
    // if (isNoNoc && !isLowRiskCase) {
    //   Modal("NOC required", "Please select at least one NOC.", "error");
    //   return;
    // }
    const plainText = stripHtmlTags(remarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    // let currentAction = "APPROVED";
    try {
      const additionalDetails = {
        ...params?.additionalDetails,
        //  fieldinspection_pending: getfeildInspection(applicationData),
        //  pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: currentAction.action,
        comment: remarks,
        comments: remarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction.action + " DOC",
                fileName: uploadedFile?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...params,
        additionalDetails,
        workflow,
        nocDetails: { ...formData?.nocDetails, ...officerNocDetails },
        mandatoryCondition: mandatoryCondition,
        action: currentAction.action,
        comment: remarks,
        // approvalLetterId: fileStoreId,
        // approvalLetterUrl: structureCertificateUrl,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction.action + " DOC",
                fileName: uploadedFile?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const data = { ...appData };
      await updateApiCall.mutate(
        { LandUse: data },
        {
          onSuccess: async (result) => {
            if (result?.LandUse?.[0]?.applicationNo) {
              Swal.fire({
                title: "Application updated",
                text: `Action taken successfully for Application (${result?.LandUse?.[0]?.applicationNo})!`,
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
            }
            Digit?.SessionStorage.del("EMP_LANDUSE");
            Digit?.SessionStorage.del("isDocValidated");
          },
        }
      );
      console.log("loggingupdatePayloadLandUSe", data, params?.khasraDetails?.length);
    } catch (error) {
      console.log(error);
    }
  }
  function handleChangeForward() {
    if (actions?.[0]?.action === "FORWARD_TO_DEPARTMENT") {
      try {
        const additionalDetails = {
          ...formData?.additionalDetails,
          // fieldinspection_pending: getfeildInspection(formData),
          // pendingapproval: getPendingApprovals() || [],
        };
        const workflow = {
          action: "FORWARD_TO_DEPARTMENT",
          comment: remarks,
          comments: remarks,
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: currentAction.action + " DOC",
                  fileName: uploadedFile?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...formData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "FORWARD_TO_DEPARTMENT",
          comment: remarks,
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: currentAction.action + " DOC",
                  fileName: uploadedFile?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
          if (result?.LandUse?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
            });
            // window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${result?.LandUse?.[0]?.applicationNo}/${tenantId}?tenantId=${tenantId}?flow=${result?.LandUse?.[0]?.applicationType}`}`);
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  async function handleChangePayment() {
    if (actions?.[0]?.action === "MAKE_PAYMENT") {
      const additionalDetails = {
        ...formData?.additionalDetails,
        // fieldinspection_pending: getfeildInspection(applicationData),
        // pendingapproval: getPendingApprovals() || [],
      };
      const workflow = {
        action: "MAKE_PAYMENT",
        comment: "Payment Done",
        comments: "Payment Done",
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: actions + " DOC",
                fileName: uploadedFile?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...formData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        action: "MAKE_PAYMENT",
        comments: "Payment Done",
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction.action + " DOC",
                fileName: uploadedFile?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
        if (result?.LandUse?.length > 0) {
          console.log("resultFromLandUseUpdate", result);

          // setShowToast({
          //   key: "true",
          //   error: false,
          //   message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
          // });
          // history.push(
          //   `${citizenBaseUrl}/payment/collect/${result?.LandUse?.[0]?.businessService}/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          // );
          setShowToast({
            key: "true",
            error: false,
            message: `Application Updated Successfully! Redirecting to the payment page...`,
          });
          //   `${citizenBaseUrl}/payment/collect/${result?.LandUse?.[0]?.businessService}/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          window.location.assign(
            `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${result?.LandUse?.[0]?.applicationNo}/${tenantId}/tenantId=${tenantId}`
          );
        }
      });
    }
    if (actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE") {
      try {
        const additionalDetails = {
          ...formData?.additionalDetails,
          // fieldinspection_pending: getfeildInspection(applicationData),
          // pendingapproval: getPendingApprovals() || [],
        };
        const workflow = {
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile
            ? [
                {
                  documentType: currentAction.action + " DOC",
                  fileName: uploadedFile?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        const appData = {
          ...formData,
          documents: formData?.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comments: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile
            ? [
                {
                  documentType: currentAction.action + " DOC",
                  fileName: uploadedFile?.name,
                  fileStoreId: uploadedFile,
                },
              ]
            : null,
        };
        /////
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({ LandUse: appData }, tenantId).then((result) => {
          if (result?.LandUse?.length > 0) {
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result?.LandUse?.[0]?.applicationNo}) Updated Successfully!`,
            });
            history.replace(
              `${citizenBaseUrl}/payment/collect/${params?.businessService}/${params?.applicationNo}/${tenantId}/tenantId=${tenantId}`,
              { data: params }
            );
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  const handleNoWorkflow = (updatedDocuments) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);

    const appData = {
      ...params,
      workflow,
      documents: updatedDocuments,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { LandUse: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          setDeveloperUpdateDocument("DocumentDetailsUpdated");
          onSelect("", result?.LandUse?.[0]);
          // const isDocValidated = result?.LandUse?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          const isDocValidated = result?.LandUse?.[0]?.documents
            ?.filter((item) => !excludedTypesForDocSection.includes(item.documentType))
            .every((item) => !item.isMandatory || item.documentRemarks !== null);
          Digit?.SessionStorage.set("isDocValidated", isDocValidated); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          //  Modal(`Documents updated`, `Documents details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };

  const handleAdditionalComment = () => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      additionalComment: additionalComment,
    };
    updateApiCall.mutate(
      { LandUse: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate1212123", result);
          Modal("Additional Comment Added", "Additional Comment Added Successfully !", "success");
          onSelect("", result?.LandUse?.[0]);
        },
        onError: (err) => {
          console.log("Error21", err);
          Modal("Update Error", "Something went wrong!!", "error");
        },
      }
    );
  };

  const handleChecklistNoWorkflow = (conversionChecklist) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    console.log("checklistFromNoworkflow", conversionChecklist);

    const appData = {
      ...params,
      workflow,
      conversionChecklist: conversionChecklist,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { LandUse: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.LandUse?.[0]);
          Modal(`Checklist Saved`, `Checklist details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  const handleNoWorkflowWithData = (data) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);

    const appData = {
      ...formData,
      ...data,
      workflow,
    };
    updateApiCall.mutate(
      { LandUse: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.LandUse?.[0]);
          //Modal(`Application updated.`, `Application Updated Successfully!`, "success", null, () => window.location.reload());
          Modal(`Application updated.`, `Application Updated Successfully!`, "success");
        },
      }
    );
  };
  const updateKhasraDetails = (khasraDetails, khasraRemarks) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }

    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);

    const appData = {
      ...params,
      workflow,
      khasraDetails,
      khasraRemarks,
      // taxHeadEstimates: [...formData?.taxHeadEstimates, ...taxHeadData] || [],
      // inspectionDetailData:
      //     userRolesArray?.[0]?.code === "JE"
      //         ? data
      //         : formData?.inspectionDetailData,
    };
    updateApiCall.mutate(
      { LandUse: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.LandUse?.[0]);
          //  const isDocValidated = result?.LandUse?.[0]?.documents?.some((item) => item.documentRemarks !== null);
          // Digit?.SessionStorage.set("isDocValidated", isDocValidated); // Modal(`Application updated.`, `Application Updated Successfully!`, "success", "/digit-ui/employee");
          Modal(`Land Use details updated`, `Khasra details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  const handleGetNotingById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksNoting}applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const callNotingDetailsAPI = async () => {
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "notingDetails",
        notingDetails: {
          developerRemarks: developerRemarks,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223Noting", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Noting remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetNotingById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  const callDocumentDetailsAPI = async () => {
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "DocumentDetails",
        documentDetails: {
          dataRecommendation: dataRecommendationDocument,
          developerRemarks: developerRemarksDocument,
          documents: updatedDocuments,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal(`Documents updated`, `Documents details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
    //  Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetDocumentById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  const callKhasraDetailsApi = async (khasraDetails = {}, khasraRemarks) => {
    // console.log("selectedObjection1", selectedObjection);

    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN",
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo?.id || null,
          name: userInfo?.name || null,
          employeeName: userInfo?.name || null,
          role: userRolesArray?.[0]?.code,
          applicationID: formData?.applicationNo,
          designation: userRolesArray?.[0]?.name,
          applicationStatus: formData?.status,
        },
        isApproved: "khasraDetails",
        khasraDetails,
        khasraRemarks,
        documentDetails: {
          dataRecommendation: dataRecommendationDocument,
          developerRemarks: developerRemarksDocument,
          documents: updatedDocuments,
        },
      },
    };

    try {
      const Resp = await axios.post(Urls.bpaService.remarksDetail, postData, {}).then((response) => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    // Modal("Documents remarks saved.", `Remarks for <strong>${formData?.applicationNo}</strong> saved successfully`, "success");
    await handleGetKhasraById(formData?.applicationNo);
    handleChange(undefined, "2");
  };

  const handleDocView = () => {
    setCurrentView((prev) => (prev === "documents" ? "viewDocuments" : "documents"));
  };
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = (value) => {
    setCurrentAction(value);
  };
  const filters = {
    // appType:formType,
    applicationNo: id,
  };
  useEffect(() => {
    // const isDocValidated = formData?.documents?.some((item) => item.documentRemarks !== null);
    const isDocValidated = formData?.documents
      ?.filter((item) => !excludedTypesForDocSection.includes(item.documentType))
      .every((item) => !item.isMandatory || item.documentRemarks !== null);
    console.log("loggingIsDocValidated", isDocValidated);

    Digit?.SessionStorage.set("isDocValidated", isDocValidated);
  }, []);

  // useEffect(() => {
  //   if (
  //     dataRecommendationDocument &&
  //     developerRemarksDocument &&
  //     updatedDocuments?.filter((doc) => doc.isMandatory)[0]?.documentRemarks &&
  //     developerUpdateDocument === "DocumentDetailsUpdated"
  //   ) {
  //     callDocumentDetailsAPI();
  //   }
  // }, [dataRecommendationDocument, developerRemarksDocument, updatedDocuments?.[0]?.documentRemarks, developerUpdateDocument]);

  useEffect(() => {
    handleGetDocumentById(formData?.applicationNo);
    handleGetNotingById(formData?.applicationNo);
    handleGetKhasraById(formData?.applicationNo);
  }, [formData?.applicationNo]);
  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    handleNoWorkflowWithData,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    developerUpdateDocument,
    handleChecklistNoWorkflow,
    isFromDashboard,
    callDocumentDetailsAPI,
    avpData,
    avpUnits,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
  };
};
export default useEmpLandUse;
